import { render, staticRenderFns } from "./dispatch.vue?vue&type=template&id=c60dafbc&scoped=true&"
import script from "./dispatch.vue?vue&type=script&lang=js&"
export * from "./dispatch.vue?vue&type=script&lang=js&"
import style0 from "./dispatch.vue?vue&type=style&index=0&id=c60dafbc&prod&scoped=true&lang=css&"
import style1 from "./dispatch.vue?vue&type=style&index=1&id=c60dafbc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60dafbc",
  null
  
)

export default component.exports